<template>
    <footer class="footer"
            :class="{[`footer-${type}`]: type}"
            :data-background-color="backgroundColor">
        <div class="container">
            <nav>
                <ul>

<!--                     
                    <li>
                        <a href="https://www.creative-tim.com">
                            Creative Tim
                        </a>
                    </li>
 -->

                    <li>
                        <a href="#/products/prada">
                            PRODUCTS
                        </a>
                    </li>
                    <li>
                        <a href="#/customers">
                            CUSTOMERS
                        </a>
                    </li>
                    <li>
                        <a href="#/aboutus">
                            ABOUT US
                        </a>
                    </li>
                </ul>
            </nav>
            <div class="copyright">
                &copy; {{year}}, <a href="https://www.creative-tim.com" target="_blank">AiCAR Team</a>.
                
                <!-- 
                Designed by
                <a href="https:///www.invisionapp.com" target="_blank">Invision</a>. Coded by
                <a href="https://github.com/cristijora" target="_blank">Cristi Jora</a> and
                 -->
                 
            </div>
        </div>
    </footer>
</template>
<script>
  export default {
    props: {
      backgroundColor: String,
      type: String
    },
    data(){
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>
<style>
</style>
